// extracted by mini-css-extract-plugin
export default {"preserveNewLine":"Layout_preserveNewLine__jStYT","langEN":"Layout_langEN__IrFLy","langTH":"Layout_langTH__nMyIz","container":"Layout_container__nqBu4"};